<template>
  <div class="wDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="codesss" v-for="(item,i) in setDetail">
      <p>青秀山闸机码</p>
      <img :src="baseUrl+item.codeImg" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setDetail:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },  

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },


      getDetail:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/order/codeImg',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .wDetailApp{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }
  .codesss{
    margin-bottom:30px
  }
  .codesss p{
    text-align:center;
    padding:8px 0
  }
  .codesss img{
    display:block;
    width:50%;
    margin:0 auto
  }
  
</style>